import { Injectable } from '@angular/core';
import { SyncService } from '../OffService/sync.service';
import { ApiRequestService, HttpRequestType } from '../OffService/api-request.service';
import { RequestHandler } from '../OffService/request-handler';
import { TrazabilidadModel } from 'src/app/models/stock/trazabilidad.model';

@Injectable({
    providedIn: 'root'
})
export class TrazabilidadApiService {

    public trazabilidad = {
        GET: new RequestHandler<TrazabilidadModel[]>(),
        POST: new RequestHandler<TrazabilidadModel[]>(),
        PUT: new RequestHandler<TrazabilidadModel[]>(),
        DELETE: new RequestHandler<TrazabilidadModel>()
    };

    constructor(
        private syncService: SyncService<TrazabilidadModel[]>,
        private syncServiceDelete: SyncService<TrazabilidadModel>,
        private api: ApiRequestService<TrazabilidadModel[]>,
        private apiDelete: ApiRequestService<TrazabilidadModel>,
    ) {
        this.defineTrazabilidad();
    }

    private defineTrazabilidad() {
        this.trazabilidad.GET.fetch(HttpRequestType.GET, 'stock/trazabilidad_get');
        this.trazabilidad.POST.fetch(HttpRequestType.POST, 'generic/trazabilidad');
        this.trazabilidad.PUT.fetch(HttpRequestType.PUT, 'generic/trazabilidad');
        this.trazabilidad.DELETE.fetch(HttpRequestType.DELETE, 'generic/trazabilidad');

        this.api.registerRequest(this.trazabilidad.GET);
        this.api.registerRequest(this.trazabilidad.POST);
        this.api.registerRequest(this.trazabilidad.PUT);
        this.apiDelete.registerRequest(this.trazabilidad.DELETE);

        this.syncService.register(this.syncService.baseSyncPolicy(this.trazabilidad.GET));
        this.syncService.register(this.syncService.baseSyncPolicy(this.trazabilidad.POST));
        this.syncService.register(this.syncService.baseSyncPolicy(this.trazabilidad.PUT));
        this.syncServiceDelete.register(this.syncServiceDelete.baseSyncPolicy(this.trazabilidad.DELETE));
    }
}